import {BaseApiService} from './baseApiService.js';

export class InfoApiService extends BaseApiService {
    
    constructor() {
        let route_map = {
            "allApi": "api/bridge",
            "uploadFiles": "api/bridge",
         } 
        super(route_map);
    }

    async allApi( body , params = {}){
        let config = {
            headers: {
                'Accept': 'application/json'
            },
            method: "POST",
            body: JSON.stringify(body),
            redirect: 'follow'
        }
        let response = await this.server_fetch('allApi', null, null, config, params);
        return response
    }
    async uploadFiles( formdata){
        let config = {
            headers: {
                'Accept': 'application/json',
            },
            method: "POST",
            body: formdata,
            redirect: 'follow'
        }
        let response = await this.server_fetch('uploadFiles', null, 'upload', config);
        return response
    }

}